import React from 'react';
import SearchableSelect from '../SearchableSelect/SearchableSelect';
import { IQualityItem } from '../../../modules/API/Defaults/models/quality';
import TagIcon from '../../icons/IconLib/TagIcon';

interface Props {
    qualities: IQualityItem[];
    value: IQualityItem | null;
    onSelect: (q: IQualityItem | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    className?: string;
}

const QualitySelector: React.FC<Props> = ({
    qualities,
    value,
    onSelect,
    placeholder = 'בחר איכות',
    disabled,
    readOnly,
    className,
}) => (
    <SearchableSelect<IQualityItem>
        items={qualities}
        value={value}
        onSelect={onSelect}
        getKey={(q) => q.QualityID}
        getLabel={(q) => (q.QualityDesc ?? '').trim()}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        leadingIcon={<TagIcon />}
        className={className}
        emptyLabel='אין איכויות מתאימות'
    />
);

export default QualitySelector;
